import { render } from "./DiscountRule.vue?vue&type=template&id=06870c87&scoped=true"
import script from "./DiscountRule.vue?vue&type=script&lang=js"
export * from "./DiscountRule.vue?vue&type=script&lang=js"

import "./DiscountRule.vue?vue&type=style&index=0&id=06870c87&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06870c87"]])

export default __exports__